import { ReactElement, ReactNode, useEffect } from 'react'
import produce from 'immer'
import { cloneDeep, findIndex } from 'lodash-es'
import create from 'zustand'
import { combine } from 'zustand/middleware'
import { validate } from '../middleware'
import { augmentProposal } from '../structuralPlanningStore/utils'

interface Props {
  children: ReactNode
}

interface StiffeningInitialState {
  stiffeningIntervals: StiffeningSegment[]
}

interface StiffeningStoreType extends StiffeningInitialState {
  setStiffeningIntervals: (stiffeningIntervals: StiffeningSegment[]) => void
  updateInterval: (guid: string, interval: Interval, effective_height: number) => void

  clear: () => void
}

const initialState: StiffeningInitialState = {
  stiffeningIntervals: [],
}

const createStore = () =>
  create<StiffeningStoreType>(
    validate(
      combine(cloneDeep(initialState), set => ({
        clear: () => set(cloneDeep(initialState)),

        setStiffeningIntervals: (stiffeningIntervals: StiffeningSegment[]) =>
          set({ stiffeningIntervals: augmentProposal(stiffeningIntervals) }),

        updateInterval: (guid: string, interval: StiffeningSegment, effective_height: number) =>
          set(
            produce(state => {
              const index = findIndex(state.stiffeningIntervals, ['guid', guid])

              state.stiffeningIntervals[index].interval = interval
              state.stiffeningIntervals[index].effective_height = effective_height
            }),
          ),
      })),
    ),
  )

const useStiffeningStore = createStore()

const StiffeningStoreProvider = ({ children }: Props): ReactElement => {
  const clear = useStiffeningStore(state => state.clear)

  useEffect(() => {
    return () => clear()
  }, [])

  return <>{children}</>
}

export { StiffeningStoreProvider, useStiffeningStore }
